module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageInfo.shopName),
      expression: "pageInfo.shopName"
    }],
    staticClass: "center-input fs-28",
    attrs: {
      "type": "search",
      "placeholder": "搜索柜子"
    },
    domProps: {
      "value": (_vm.pageInfo.shopName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pageInfo, "shopName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("\n                搜索\n            ")])]), _vm._v(" "), (!_vm.isCabinetToolBuyerRole) ? _c('div', {
    staticClass: "page-state"
  }, [_c('van-tabs', {
    attrs: {
      "swipeable": "",
      "swipe-threshold": 5,
      "line-width": '.6rem'
    },
    on: {
      "click": _vm.tabClick
    },
    model: {
      value: (_vm.tabActive),
      callback: function($$v) {
        _vm.tabActive = $$v
      },
      expression: "tabActive"
    }
  }, _vm._l((_vm.tabList), function(item, $index) {
    return _c('van-tab', {
      key: $index,
      attrs: {
        "title": item.title,
        "name": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "list-item",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'supplyRecordDetail',
            query: {
              batchNo: item.batchNo,
              eqType: item.equipmentType
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "flex supply-top-name bd-bot"
    }, [_c('div', {
      staticClass: "supply-label"
    }, [_vm._v(_vm._s(_vm.equipment_type[item.equipmentType]))]), _vm._v(" "), _c('div', {
      staticClass: "flex1 color-333"
    }, [_vm._v(_vm._s(item.shopName))]), _vm._v(" "), (!_vm.isCabinetToolBuyerRole) ? _c('div', {
      staticClass: "ml-20",
      class: item.isVerify == '0' ? 'color-org' : 'color-000'
    }, [_vm._v(_vm._s(item.isVerify == '0' ? '待确认' : "已处理") + "\n                        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "pd-25"
    }, [_c('div', {
      staticClass: "flex-between fs-28 color-999"
    }, [_c('div', [_vm._v("补货人：" + _vm._s(item.linkName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), (item.equipmentType == 'rfid') ? _c('div', [_c('div', {
      staticClass: "flex-center mt-30 fs-28"
    }, [(!_vm.isCabinetToolBuyerRole) ? _c('div', {
      staticClass: "mr-50",
      class: item.addTypeCount && item.addTypeCount != 0 ? 'color-org font-bold' : 'color-999'
    }, [_vm._v("补货品种：" + _vm._s(item.addTypeCount))]) : _vm._e(), _vm._v(" "), _c('div', {
      class: item.minusTypeCount && item.minusTypeCount != 0 ? 'color-main font-bold' : 'color-999'
    }, [_vm._v("取货品种：" + _vm._s(item.minusTypeCount))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-center mt-8 fs-28"
    }, [(!_vm.isCabinetToolBuyerRole) ? _c('div', {
      staticClass: "mr-50",
      class: item.addNum && item.addNum != 0 ? 'color-org font-bold' : 'color-999'
    }, [_vm._v("补货数量：" + _vm._s(item.addNum))]) : _vm._e(), _vm._v(" "), _c('div', {
      class: item.minusNum && item.minusNum != 0 ? 'color-main font-bold' : 'color-999'
    }, [_vm._v("取货数量：" + _vm._s(item.minusNum))])])]) : _vm._e(), _vm._v(" "), (item.equipmentType == 'weigh') ? _c('div', [_c('div', {
      staticClass: "flex-center mt-30 fs-28"
    }, [(!_vm.isCabinetToolBuyerRole) ? _c('div', {
      staticClass: "mr-50",
      class: item.addTypeCount && item.addTypeCount != 0 ? 'color-org font-bold' : 'color-999'
    }, [_vm._v("补货品种：" + _vm._s(item.addTypeCount))]) : _vm._e(), _vm._v(" "), _c('div', {
      class: item.minusTypeCount && item.minusTypeCount != 0 ? 'color-main font-bold' : 'color-999'
    }, [_vm._v("取货品种：" + _vm._s(item.minusTypeCount))])])]) : _vm._e(), _vm._v(" "), (item.equipmentType == 'spring') ? _c('div', [_c('div', {
      staticClass: "flex-center mt-30 fs-28"
    }, [_c('div', {
      staticClass: "color-org mr-50"
    }, [_vm._v("补货货道：")]), _vm._v(" "), _c('div', {
      staticClass: "color-999"
    }, [_vm._v("换绑货道：")])]), _vm._v(" "), _c('div', {
      staticClass: "flex-center mt-15 fs-28"
    }, [_c('div', {
      staticClass: "color-org"
    }, [_vm._v("补货数量：" + _vm._s(item.addNum))])])]) : _vm._e(), _vm._v(" "), (item.equipmentType == 'consign') ? _c('div', [_c('div', {
      staticClass: "flex-center mt-30 fs-28"
    }, [(!_vm.isCabinetToolBuyerRole) ? _c('div', {
      staticClass: "color-org mr-50"
    }, [_vm._v("补货品种：" + _vm._s(item.addTypeCount))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "color-999"
    }, [_vm._v("取货数量：" + _vm._s(item.minusNum))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-center mt-15 fs-28"
    }, [_c('div', {
      staticClass: "color-999"
    }, [_vm._v("换绑货道：")])])]) : _vm._e()])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60d4cfb8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/supplyRecord/list.vue
// module id = YPI0
// module chunks = 51